import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from "@angular/core";
import {ModalDirective} from "ngx-bootstrap";

@Component({
  selector: 'vb-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('modal')
  modal: ModalDirective;

  @Input()
  confirmQuestion: string = "Sind Sie sicher?";

  @Input()
  confirmTitle: string;

  @Input()
  helpText: string;

  @Input()
  danger: boolean = false;

  @Output()
  confirmClicked: EventEmitter<any> = new EventEmitter();

  @Output()
  cancelClicked: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.show();
  }

  ngOnDestroy() {

  }

  show() {
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }

  onClose() {
    return this.modal.onHidden;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/dialogs/dialog/dialog.component.ts